import { render, staticRenderFns } from "./KSelect.vue?vue&type=template&id=3b84e925&scoped=true&lang=pug&"
import script from "./KSelect.vue?vue&type=script&lang=ts&"
export * from "./KSelect.vue?vue&type=script&lang=ts&"
import style0 from "./KSelect.vue?vue&type=style&index=0&id=3b84e925&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84e925",
  null
  
)

export default component.exports